// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
export interface IEvent {
  severity?: SEVERITY;
  type: EVENT_TYPES;
  description: string;
  detail: string;
}

export enum SEVERITY {
  NOT_SET = 0,
  DEBUG = 10,
  INFO = 20,
  WARNING = 30,
  ERROR = 40,
}

export enum EVENT_TYPES {
  NAVIGATION = 'navigation',
  MAP_LOAD = 'map_load',
  DECRYPT_HEADER = 'decrypt_header',
  DECRYPT_FILE = 'decrypt_file',
  DECRYPT_FILE_DOWNLOAD = 'decrypt_download',
  ADMIN_EVENT = 'admin_event',
  PBA_FILE_DOWNLOAD = 'pba_license_downloaded',
  PBA_LICENSE_COPIED = 'pba_license_copied',
  FDE_LICENSE_COPIED = 'fde_license_copied',
  FDE_FILE_DOWNLOAD = 'fde_license_downloaded',
}

export interface IEventSearchRequest {
  pageStart: number;
  pageSize: number;
  timeHigh: number;
  timeLow: number;
  search: string;
  sources: string[];
  severity: number;
  event_types: string[];
  selectedOrgId: string;
  sorts: {
    sortAttr: string,
    sortOrder: string;
  }[];
  translate?: boolean; // used in the dashboard
}

export interface IEventResponseElement {
  data: string;
  description: string;
  detail: string;
  groupName: string;
  id: number;
  integrationName: string;
  severity: number;
  severityDisplay: string;
  source: number;
  timestamp: number;
  timestampStr: string;
  type: string;
  username: string;
}


export interface IEventSearchResponse {
  totalCount: number;
  events: IEventResponseElement[];
  query?: IEventSearchRequest;
}

export interface IEventColumnsRequest {
  severities: string[];
  types: string[];
}
